import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';
import gql from 'graphql-tag';
import { useSelector, useDispatch, usePrevious } from '~Hooks';
import { useQuery } from '@apollo/client';
import { venueTimeout } from './__queries__';
import * as actions from '~actions';
import { useStorage } from '~Components/Storage';

const VENUE_TIMEOUT = gql`
  query venueTimeout($id: ID!) {
    venue: Venue(id: $id) {
      id
      staffIdleTimeout
    }
  }
`;

const StaffIdleTimeout = (): null => {
  const location = useLocation();
  const [, , venueId] = location.pathname.split('/');
  const isInVenue = window.location.hash.includes('/venue/') && !!venueId;
  const timeOfLastAction = useSelector((state) => state.timeOfLastAction);
  const staffId = useSelector((state) => state.staff?.id);
  const company = useSelector((state) => state.company);
  const previousCompany = usePrevious(company);
  const [storage] = useStorage();

  const dispatch = useDispatch();
  const { data } = useQuery<venueTimeout>(VENUE_TIMEOUT, {
    variables: { id: venueId },
    skip: !venueId,
  });

  const staffIdleTimeout = data?.venue?.staffIdleTimeout;

  // Timeout staff while idling is staffIdleTimeout is set
  useEffect(() => {
    const timeout = setInterval(() => {
      if (!staffId || !staffIdleTimeout || !isInVenue || storage.disableStaffTimeout) {
        clearInterval(timeout);
        return;
      }

      if (
        moment(timeOfLastAction)
          .add(staffIdleTimeout, 'seconds')
          .isBefore(moment())
      ) {
        dispatch(actions.staffLogout());
        return;
      }
    }, 5000);
    return () => clearInterval(timeout);
  }, [staffId, timeOfLastAction, staffIdleTimeout]);

  // Logout staff if company changes
  useEffect(() => {
    if (company !== previousCompany) {
      dispatch(actions.staffLogout());
    }
  }, [company, previousCompany]);

  return null;
};

export default StaffIdleTimeout;
